module.exports = __webpack_public_path__ + "img/a-s-1.4baad41c.jpg";